import { WizardStep, AppWizardState } from '../../models/app-wizard-state';

export abstract class WizardPageContent {
	readonly stepIndex: WizardStep;
	constructor(stepIndex: WizardStep, state: AppWizardState) {
		this.stepIndex = stepIndex;
		state.errorInPage = false;
	}
	abstract checkError(): boolean;

	abstract checkErrorForDraft(): boolean;
}
